import React, { Component } from 'react';
import { toast } from 'react-toastify';
import { Button, Modal, Loading, Checkbox, TextArea } from 'carbon-components-react';
import Numeral from 'numeral';
import 'numeral/locales/pt-br';
import { NavLink } from 'react-router-dom';
import { Breadcrumb, ExpandableCard } from '../../../components';
import { pathDmService } from '../../../services/Api';

class CheckoutTrade extends Component {
  constructor() {
    super();

    this.state = {
      // items: [],
      numeroPedido: '#',
      campanhaComCliente: false,
      relacionamentoEmLoja: false,
      aniversarioLojista: false,
      aniversarioLoja: false,
      aniversarioParceria: false,
      brindePitShop: false,
      implamtacao: false,
      outro: false,
      descricaoMotivo: '',
    };
  }

  componentDidMount = async () => {
    Numeral.locale('pt-br');
  };

  onsubmit = async e => {
    const {
      campanhaComCliente,
      relacionamentoEmLoja,
      aniversarioLojista,
      aniversarioLoja,
      aniversarioParceria,
      brindePitShop,
      implamtacao,
      outro,
      descricaoMotivo,
    } = this.state;
    e.preventDefault();
    if (e.target.checkValidity()) {
      this.setState({ isSaving: true });
      try {
        const dados = {
          campanhaComCliente,
          relacionamentoEmLoja,
          aniversarioLojista,
          aniversarioLoja,
          aniversarioParceria,
          brindePitShop,
          implamtacao,
          outro,
          descricaoMotivo,
        };
        const resultado = await pathDmService('/Pedido/GeraPedidoBrinde', dados);
        this.setState({ numeroPedido: resultado.codigo }, this.toggleModal);
      } catch (ex) {
        if (ex && ex.code === 400 && ex.message) toast.error(ex.message);
        else toast.error('Ocorreu uma falha ao fechar seu pedido');
      }

      this.setState({ isSaving: false });
    }
  };

  toggleModal = () => {
    this.setState(prevState => ({
      openModal: !prevState.openModal,
      selectedId: null,
    }));
  };

  onChangeCheck = (val, id, event) => {
    this.setState({ [event.target.name]: val });
  };

  onChangeText = event => {
    this.setState({ [event.target.id]: event.target.value /* , isEdited: true */ });
  };

  render() {
    const {
      numeroPedido,
      isSaving,
      campanhaComCliente,
      relacionamentoEmLoja,
      aniversarioLojista,
      aniversarioLoja,
      aniversarioParceria,
      brindePitShop,
      implamtacao,
      outro,
      openModal,
      descricaoMotivo,
    } = this.state;
    const { history } = this.props;
    return (
      <div>
        <Breadcrumb
          title=" Finalizar Pedido de Trade "
          description=" Preencha as Informações abaixo: "
          renderLeft={(() => (
            <div className="breadcrumb-left-actions">
              <NavLink to="/carrinho">
                <svg width="16" height="14" viewBox="0 0 16 14">
                  <path d="M4.044 8.003l4.09 3.905-1.374 1.453-6.763-6.356L6.759.639 8.135 2.09 4.043 6.003h11.954v2H4.044z" />
                </svg>
              </NavLink>
            </div>
          ))()}
        />
        <section className="content-wrapper content-wrapper--large">
          <form
            id="form"
            onSubmit={async e => {
              await this.onsubmit(e);
            }}
          >
            <ExpandableCard className="center-box" title="Motivo" expanded>
              <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                <Checkbox
                  name="campanhaComCliente"
                  id="campanhaComCliente"
                  defaultChecked={campanhaComCliente}
                  labelText="Campanha com cliente"
                  onChange={this.onChangeCheck}
                />
                <Checkbox
                  name="relacionamentoEmLoja"
                  id="relacionamentoEmLoja"
                  defaultChecked={relacionamentoEmLoja}
                  labelText="Ação de relacionamento em Loja"
                  onChange={this.onChangeCheck}
                />
                <Checkbox
                  name="aniversarioLojista"
                  id="aniversarioLojista"
                  defaultChecked={aniversarioLojista}
                  labelText=" Aniversário Lojista "
                  onChange={this.onChangeCheck}
                />
                <Checkbox
                  name="aniversarioLoja"
                  id="aniversarioLoja"
                  defaultChecked={aniversarioLoja}
                  labelText=" Aniversário Loja "
                  onChange={this.onChangeCheck}
                />
                <Checkbox
                  name="aniversarioParceria"
                  id="aniversarioParceria"
                  defaultChecked={aniversarioParceria}
                  labelText=" Aniversário Parceria "
                  onChange={this.onChangeCheck}
                />
                <Checkbox
                  name="brindePitShop"
                  id="brindePitShop"
                  defaultChecked={brindePitShop}
                  labelText=" Brinde Pit Stop "
                  onChange={this.onChangeCheck}
                />
                <Checkbox
                  name="implamtacao"
                  id="implamtacao"
                  defaultChecked={implamtacao}
                  labelText=" Implantação "
                  onChange={this.onChangeCheck}
                />
                <Checkbox
                  name="outro"
                  id="outro"
                  defaultChecked={outro}
                  labelText="Outro"
                  onChange={this.onChangeCheck}
                />
              </div>
              {outro && (
                <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                  <TextArea
                    id="descricaoMotivo"
                    labelText="Motivo"
                    onChange={this.onChangeText}
                    value={descricaoMotivo}
                    placeholder="Descreva o motivo."
                  />
                </div>
              )}
            </ExpandableCard>
            <div className="bx--col-xs-12  v-md-margin checkout-actions">
              <NavLink to="/carrinho">Voltar para o Carrinho</NavLink>
              <Button kind="primary" className="btn-secondary-color" type="submit">
                Concluir
              </Button>
            </div>
          </form>
        </section>
        <Modal
          open={openModal}
          className="confirm-trade"
          onRequestSubmit={() => {
            history.push('/pedidos/trade');
          }}
          onRequestClose={() => {
            history.push('/pedidos/trade');
          }}
          modalHeading="Pedido Feito com Sucesso "
          primaryButtonText="Meus Pedidos"
          secondaryButtonText=" Voltar para a Loja "
        >
          <div className="warning-modal-txt">
            <p>
              <strong>
                {`Seu pedido ${numeroPedido} está sob avaliação.`}
              </strong>
            </p>
            <p className="finalizado-pedido">
              A qualquer momento você poderá acompanhá-lo clicando no ícone
              {' '}
              <a className="notifications pointer" href="/pedidos">
                <i className="assignment icon-orange" />
              </a>
              {' '}
              <br />
              disponível no canto superior da sua tela.
            </p>
          </div>
        </Modal>
        {isSaving && <Loading small />}
      </div>
    );
  }
}
export default CheckoutTrade;



// WEBPACK FOOTER //
// ./src/screens/client/cart/checkoutTrade.js